export default {
  validate: (value, { minValue, maxValue, required = true }) => {
    return {
      required,
      valid: /^[0-9]+$/.test(value) && Number(minValue) <= value && Number(maxValue) >= value,
    };
  },
  params: ['minValue', 'maxValue', 'required'],
  computesRequired: true,
  message: (fieldName, { _value_: v, minValue, maxValue }) => {
    if (!v) return 'Please enter your mileage e.g. 5000.';
    if (!/^[0-9]+$/.test(v)) return 'Please only enter numbers e.g. 5000.';
    return `Please enter a numeric value between ${minValue} and ${maxValue}.`;
  },
};
